<template>
  <span
    class="match-result match-result-standard flex-center font-bold"
    v-if="!isTennis">
    <span class="result-period color-important text-center">
      {{ customResult || matchStatus.result }}
    </span>
    <span v-if="isCricket">
      :
    </span>
    <span class="result-period color-faded text-center">
      {{ resultPeriod }}
    </span>
  </span>
  <MatchInfoResultsTennis
    class="match-result"
    :game-score="matchStatus.gameScore"
    :result-period="resultPeriod"
    v-else-if="isTennis"
  />
</template>

<script>
import { sport, resultPeriodStandard } from '@/services/mixins';
import MatchInfoResultsTennis from './MatchInfoResultsTennis.vue';

export default {
  name: 'MatchResults',
  mixins: [sport, resultPeriodStandard],
  components: {
    MatchInfoResultsTennis,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
  computed: {
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    customResult() {
      if (this.idSport === 21) {
        const data = this.$store.getters.getMatchStatus(this.idMatch);
        return `${data.result.split(':')[0]}/${data.dismissals[0]}`;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-result {
  height: 100%;
  font-size: 0.875rem;
}

.result-period {
  width: 50%;
}
</style>
